
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#CCE8FF","d":"M8 15v9h9l13 6.5V25z"}}),_c('path',{attrs:{"stroke":"#2196F3","stroke-width":"2","d":"M17 13v12H9a2 2 0 01-2-2v-8a2 2 0 012-2h8z"}}),_c('path',{attrs:{"fill":"#CCE8FF","stroke":"#2196F3","stroke-width":"2","d":"M32 22.874a4.002 4.002 0 000-7.748v7.748z"}}),_c('path',{attrs:{"stroke":"#2196F3","stroke-linejoin":"round","stroke-width":"2","d":"M10 25l2 6.5c.667 1.333 1.667 1.833 3 1.5 1.333-.333 2-1.167 2-2.5L15 25m2-12c1.338-.336 3.338-1.17 6-2.5a95.32 95.32 0 006.485-3.571h0A1 1 0 0131 7.786V30.24a1 1 0 01-1.508.861c-2.62-1.547-4.784-2.747-6.492-3.601a45.235 45.235 0 00-6-2.5V13z"}})])])
          )
        }
      }
    